import { render } from "./DynamicMenu.vue?vue&type=template&id=13821096&ts=true"
import script from "./DynamicMenu.vue?vue&type=script&lang=ts"
export * from "./DynamicMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13821096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13821096', __exports__)) {
    api.reload('13821096', __exports__)
  }
  
  module.hot.accept("./DynamicMenu.vue?vue&type=template&id=13821096&ts=true", () => {
    api.rerender('13821096', render)
  })

}


export default __exports__